<!--
 * @Description:
 * @Author: wjx
 * @LastEditors: Please set LastEditors
 * @Date: 2019-03-15 10:35:09
 * @LastEditTime: 2021-04-28 10:30:40
 -->
<template>
  <el-dialog
    :visible="true"
    title="关联详情"
    lock-scroll
    @close="closeEvent"
    width="800"
    top="100"
    style="margin-top:5vh;height:800px;"
  >
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      :stripe="true"
      :highlight-current-row="false"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="title"
        label="专区名称"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="projectName"
        label="项目名称"
      ></el-table-column>
    </el-table>
    <!--分页-->
    <div style="display:flex;justify-content:center;align-items:center;">
      <el-button type="primary" style="height:40px;" @click="closeEvent">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { information } from '@/api/ajax';
export default {
  components: {},
  mixins: [pageInation, initSearch],
  props: {
    linkId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // tableData: {},
      getList: information.channelProjectList, // 获取列表的AJAX
      searchQuery: {
        id: ''
      }
    };
  },
  computed: {},
  watch: {
    linkId(v) {
      this.searchQuery.id = v;
      this.getPageList();
    }
  },
  created() {
    this.searchQuery.id = this.linkId;
  },
  methods: {
    closeEvent() {
      this.$parent.showDetail = false;
    }
    // confirm(item) {
    //   this.$confirm('是否确认取票', '请确认', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     getTicket({
    //       id: item.id
    //     })
    //       .then(res => {
    //         if (res.status == 1) {
    //           this.$notify({
    //             title: '成功',
    //             message: '操作成功',
    //             type: 'success'
    //           });
    //           item.isWatch = 1;
    //         }
    //       })
    //       .catch(err => {
    //         this.$message({
    //           type: 'info',
    //           message: '已取消操作'
    //         });
    //       });
    //   });
    // }
  }
};
</script>
<style lang="scss" scoped>
.confirnBtn {
  position: absolute;
  width: 100px;
  height: 50px;
  top: 50%;
  right: 1%;
  margin-left: -50px;
  margin-top: -25px;
  text-align: center;
  font-size: 16px;
}

.childRuleForm {
  width: 90%;
  margin-left: 4%;
  // border: 1px solid rgb(128,128,128);
}
</style>
